import { EXP_CATEGORY_LUX_PLUS_ID } from 'constants/experience'

export const EXPERIENCE_CATEGORY_ICON_SYMBOLS: Partial<Record<number, App.OfferFeatureSymbol>> = {
  // Wine & Dine
  1: 'line_restaurant',
  // Top Activities
  9: 'line_hot_air_balloon',
  // Attractions & Tickets
  18: 'line_ticket',
  // Live Events
  27: 'line_theatre',
  // Indulge Yourself
  31: 'line_wellness',
  // Travel Essentials
  35: 'line_plane_departure',
  // Lux Exclusive
  40: 'line_star',
  // Day Tours
  48: 'line_guided_tours',
  // Gift Inspiration
  56: 'line_gift',
  // LuxPlus
  [EXP_CATEGORY_LUX_PLUS_ID]: 'line_award',
}

export function getExperienceCategoryIconSymbol(category: Pick<App.ExperienceItemCategory, 'id' | 'parentId'>): App.OfferFeatureSymbol {
  return EXPERIENCE_CATEGORY_ICON_SYMBOLS[category.parentId ?? category.id] ?? 'line_sightseeing'
}
